export type QcStatus = 'done';

export type QcErrorType =
  | 'outcome'
  | 'data_missing'
  | 'data_surplus'
  | 'data_incomplete'
  | 'generic';

export type QcPeriod = '1' | '2' | '3' | 'OT';
export const QC_PERIODS: readonly QcPeriod[] = ['1', '2', '3', 'OT'];

export type QcOutcomeOption = 'delay' | 'missing shift' | 'plus minus';

export interface QcError {
  period: QcPeriod | null;
  gameTime: string | null;
  errorType: QcErrorType | null;
  collector: string | null;
  qc: string | null;
  comment: string | null;
}

export interface QcPostQcObligations {
  correction: boolean;
  qaMeeting: boolean;
  reCollection: boolean;
}

export interface QcRecord {
  totalEvents: number | null;
  errors: QcError[];
  postQcObligations: QcPostQcObligations;
  status: QcStatus | null;
}

export interface QcEvent {
  _id: string;
  code: string;
  collectorAuthId: string;
  qc: QcRecord | null;
  dcType: string | null;
  dcDate: string | null;
  gameId: string;
  gameDateTime: string | null;
  league: string | null;
  homeTeam: string;
  awayTeam: string;
}

export interface QcEventListPage {
  count: number;
  data: QcEvent[];
}

export interface QcEventFilters {
  page: number;
  pageSize: number;
  league?: string | null;
  eventCode?: string | null;
  game?: string | null;
  collectorAuthId?: string | null;
  dcDateFrom?: string | null;
  dcDateTo?: string | null;
  showAnalyzed: boolean;
}
